import Link from "next/link";
import { ArrowRight } from "lucide-react";
import { PRICE_ANCHORS } from "@/lib/facts";

/**
 * Preisanker unter dem Hero jeder Leistungsseite. Entscheidung vom
 * 2026-10-21: keine Beträge – nur Festpreis-Hinweis und Zahlungsmodell
 * (Texte in src/lib/facts.ts).
 */
export function PriceAnchor({ service }: { service: keyof typeof PRICE_ANCHORS | string }) {
  const p = PRICE_ANCHORS[service];
  if (!p) return null;
  return (
    <section aria-labelledby={`preisanker-${service}`} className="pb-4">
      <div className="mx-auto max-w-7xl px-4 lg:px-8">
        <div
          className="flex flex-col gap-4 rounded-2xl border p-5 sm:flex-row sm:items-center sm:justify-between"
          style={{ borderColor: "var(--border)", backgroundColor: "var(--card-bg)" }}
        >
          <div>
            <p id={`preisanker-${service}`} className="text-xs font-semibold uppercase tracking-wider" style={{ color: "var(--text-quaternary)" }}>
              Preise
            </p>
            <p className="mt-1 text-lg font-semibold" style={{ color: "var(--text)" }}>
              {p.headline}
            </p>
            <p className="mt-1 text-sm" style={{ color: "var(--text-tertiary)" }}>
              {p.note}
            </p>
          </div>
          <Link
            href="/beratung"
            className="inline-flex shrink-0 items-center justify-center gap-2 rounded-lg bg-brand-500 px-5 py-3 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-brand-600"
          >
            Festpreis im Erstgespräch klären
            <ArrowRight className="h-4 w-4" aria-hidden="true" />
          </Link>
        </div>
      </div>
    </section>
  );
}
